export enum Currency {
  BRL = 'BRL',
  ARS = 'ARS',
  MXN = 'MXN',
  USD = 'USD',
}
